module.exports = "<div>\n<ion-nav-bar class=\"bar-positive\">\n    <!--\n    <ion-nav-back-button>\n    </ion-nav-back-button>\n    -->\n</ion-nav-bar>\n<ion-nav-view>\n\n</ion-nav-view>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./www/templates/app.html
// module id = 3
// module chunks = 0